"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketGroupIds = void 0;
const templateIdsMap_1 = require("./templateIdsMap");
exports.MarketGroupIds = [
    templateIdsMap_1.TemplateIdsMap.HANDICAP,
    templateIdsMap_1.TemplateIdsMap.TOTAL,
    templateIdsMap_1.TemplateIdsMap.COMPETITOR1_TOTAL,
    templateIdsMap_1.TemplateIdsMap.COMPETITOR2_TOTAL,
    templateIdsMap_1.TemplateIdsMap.TOTAL_1ST_HALF,
    templateIdsMap_1.TemplateIdsMap.HANDICAP_1ST_HALF,
    templateIdsMap_1.TemplateIdsMap.TOTAL_1ST_HALF_COMPETITOR1,
    templateIdsMap_1.TemplateIdsMap.TOTAL_1ST_HALF_COMPETITOR2,
    templateIdsMap_1.TemplateIdsMap.HANDICAP_2ND_HALF,
    templateIdsMap_1.TemplateIdsMap.TOTAL_2ND_HALF,
    templateIdsMap_1.TemplateIdsMap.TOTAL_2ND_HALF_COMPETITOR1,
    templateIdsMap_1.TemplateIdsMap.TOTAL_2ND_HALF_COMPETITOR2,
    templateIdsMap_1.TemplateIdsMap.OVERTIME_TOTAL,
    templateIdsMap_1.TemplateIdsMap.OVERTIME_HANDICAP,
    templateIdsMap_1.TemplateIdsMap.OVERTIME_1ST_HALF_HANDICAP,
    templateIdsMap_1.TemplateIdsMap.TOTAL_CORNERS,
    templateIdsMap_1.TemplateIdsMap.GAME_HANDICAP,
    templateIdsMap_1.TemplateIdsMap.TOTAL_GAMES,
    templateIdsMap_1.TemplateIdsMap.TOTAL_GAMES_COMPETITOR1,
    templateIdsMap_1.TemplateIdsMap.TOTAL_GAMES_COMPETITOR2,
    templateIdsMap_1.TemplateIdsMap.HANDICAP_INCL_OVERTIME,
    templateIdsMap_1.TemplateIdsMap.TOTAL_INCL_OVERTIME,
    templateIdsMap_1.TemplateIdsMap.HANDICAP_2ND_HALF_INCL_OVERTIME,
    templateIdsMap_1.TemplateIdsMap.TOTAL_2ND_HALF_INCL_OVERTIME,
    templateIdsMap_1.TemplateIdsMap.POINT_HANDICAP,
    templateIdsMap_1.TemplateIdsMap.TOTAL_POINTS,
    templateIdsMap_1.TemplateIdsMap.GAME_GAMENUMBER_POINT_HANDICAP,
    templateIdsMap_1.TemplateIdsMap.GAME_GAMENUMBER_TOTAL_POINTS,
    templateIdsMap_1.TemplateIdsMap.HANDICAP_INCL_EXTRA_INNINGS,
    templateIdsMap_1.TemplateIdsMap.TOTAL_INCL_EXTRA_INNINGS,
    templateIdsMap_1.TemplateIdsMap.INNINGS_1TO5_HANDICAP,
    templateIdsMap_1.TemplateIdsMap.INNINGS_1TO5_TOTAL,
    templateIdsMap_1.TemplateIdsMap.INNINGS_FROMVALUE_TOVALUE_TOTAL,
    templateIdsMap_1.TemplateIdsMap.INNINGNUMBER_INNING_TOTAL,
    templateIdsMap_1.TemplateIdsMap.TOTAL_SCORELESS_INNINGS,
    templateIdsMap_1.TemplateIdsMap.INNINGS_FROMVALUE_TOVALUE_HANDICAP,
    templateIdsMap_1.TemplateIdsMap.INNINGNUMBER_INNING_HANDICAP,
    templateIdsMap_1.TemplateIdsMap.HANDICAP_INCL_OVERTIME_AND_PENALTIES,
    templateIdsMap_1.TemplateIdsMap.TOTAL_INCL_OVERTIME_AND_PENALTIES,
    templateIdsMap_1.TemplateIdsMap.COMPETITOR1_TOTAL_INCL_OVERTIME_AND_PENALTIES,
    templateIdsMap_1.TemplateIdsMap.COMPETITOR2_TOTAL_INCL_OVERTIME_AND_PENALTIES,
    templateIdsMap_1.TemplateIdsMap.COMPETITOR1_TOTAL_INCL_OVERTIME,
    templateIdsMap_1.TemplateIdsMap.COMPETITOR2_TOTAL_INCL_OVERTIME,
    templateIdsMap_1.TemplateIdsMap.TOTAL_OVER_EXACT_UNDER,
    templateIdsMap_1.TemplateIdsMap.QUARTERNUMBER_QUARTER_COMPETITOR1_TOTAL,
    templateIdsMap_1.TemplateIdsMap.QUARTERNUMBER_QUARTER_COMPETITOR2_TOTAL,
    templateIdsMap_1.TemplateIdsMap.QUARTERNUMBER_QUARTER_TOTAL,
    templateIdsMap_1.TemplateIdsMap.QUARTERNUMBER_QUARTER_HANDICAP,
    templateIdsMap_1.TemplateIdsMap.SETNUMBER_SET_POINT_HANDICAPS,
    templateIdsMap_1.TemplateIdsMap.SETNUMBER_SET_TOTAL_POINTS,
    templateIdsMap_1.TemplateIdsMap.PERIODNUMBER_PERIOD_TOTAL,
    templateIdsMap_1.TemplateIdsMap.PERIODNUMBER_PERIOD_HANDICAP,
    templateIdsMap_1.TemplateIdsMap.INNINGS_1TO5_COMPETITOR1_TOTAL,
    templateIdsMap_1.TemplateIdsMap.INNINGS_1TO5_COMPETITOR2_TOTAL,
    templateIdsMap_1.TemplateIdsMap.INNINGS_FROMVALUE_TOVALUE_COMPETITOR1_TOTAL,
    templateIdsMap_1.TemplateIdsMap.INNINGS_FROMVALUE_TOVALUE_COMPETITOR2_TOTAL,
];
//# sourceMappingURL=marketGroupIds.js.map